import { call, put, takeLatest } from "redux-saga/effects";
import remoteResource from "../../lib/RemoteResource";

import {
  PUBLIC_LEAD_CREATE_REQUESTED,
  PUBLIC_LEAD_CREATE_SUCCEEDED,
  PUBLIC_LEAD_CREATE_FAILED,
  LEAD_SEARCH_REQUESTED,
  LEAD_SEARCH_SUCCEEDED,
  LEAD_SEARCH_FAILED,
} from "../actions";

function* createPublicLead(action) {
  try {
    const { payload, captcha } = action;
    const lead = yield call(remoteResource.createPublicLead, payload, captcha);
    yield put({
      type: PUBLIC_LEAD_CREATE_SUCCEEDED,
      payload: lead.data,
    });
  } catch (e) {
    yield put({
      type: PUBLIC_LEAD_CREATE_FAILED,
      payload: e.response.data.message,
    });
  }
}

function* searchLead(action) {
  try {
    const { payload, captcha } = action;
    const lead = yield call(remoteResource.searchPublicLead, payload, captcha);
    yield put({
      type: LEAD_SEARCH_SUCCEEDED,
      payload: lead.data,
    });
  } catch (e) {
    yield put({
      type: LEAD_SEARCH_FAILED,
      payload: e.response.data.message,
    });
  }
}

export function* watchPublicLead() {
  yield takeLatest(PUBLIC_LEAD_CREATE_REQUESTED, createPublicLead);
  yield takeLatest(LEAD_SEARCH_REQUESTED, searchLead);
}
